import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/entries";

export default function Testimonials() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100 px-4 py-14 md:px-10 md:py-20">
      <div className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="font-heading text-sm font-bold tracking-[0.2em] text-accent-700">
            READER VOICES
          </span>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
            读过的人怎么说
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 text-accent-500">
            {[0, 1, 2, 3, 4].map((i) => (
              <i key={i} className="ri-star-fill" />
            ))}
          </div>
          <span className="text-sm text-foreground-600">4.9 / 5 · 来自 2,140 条读者评分</span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <blockquote className="text-sm leading-relaxed text-foreground-700">
              <i className="ri-double-quotes-l mr-1 text-lg text-primary-300" />
              {item.text}
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/about"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          了解我们的内容原则
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}